import { useCurrentModule } from '../ModuleProvider';
export const ECLIPSE_TRUST_BUILDERS_REDESIGN_SPEC = 'eclipseTrustBuildersRedesign';
export const useIsTrustBuildersRedesign = () => {
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  return experiments.isEnabled(ECLIPSE_TRUST_BUILDERS_REDESIGN_SPEC);
};
//# sourceMappingURL=useIsTrustBuildersRedesign.js.map